import { render, staticRenderFns } from "./crypto.vue?vue&type=template&id=61f4ebfa&"
import script from "./crypto.vue?vue&type=script&lang=js&"
export * from "./crypto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports